import React, { Fragment } from "react";
import Base from './Base';
import {isEyes, getTypeTable, pointCallback, hexToRgbTo} from "../ultil";
import {hexToRgba, rgbaToHex} from "@gqlapp/base/colorful/utils/convert";

export default class PointBase extends Base {

	/**
	 * getOptions
	 * @param $isDark
	 * @param $fill
	 * @param $options
	 */
	public getOptions($isDark: boolean, $fill: string, $options: any = {}): any[]{
		if (!this.$qrcode) return [];

		let { "out" : $out, "pos" : $pos } = $options || {};


		$pos = $pos || (()=>{})
		let $pointList: any[] = [];
		let $nCount: number = this.$qrcode.getModuleCount();
		let $typeTable = getTypeTable(this.$qrcode);
		let $dataOpts: any = this.getDataOptions($nCount, $options);

		pointCallback($nCount, $out, ($xp: number, $yp: number, $x: number, $y: number) => {
			let $dataDark = this.$qrcode.isDark($x, $y);
			if ((!$dataDark && $isDark) || ($dataDark && !$isDark)) return;
			if (isEyes($typeTable, $x, $y)) return;
			$pointList.push($pos(Object.assign({}, $dataOpts, { "x": $xp, "y": $yp}, { "fill": $fill })));
		});

		return $pointList.map((e, key)=> <Fragment key={key}>{e}</Fragment>);
	}

	/**
	 *
	 * @param $options
	 */
	protected otherPoints($options: any = {}): any{
		if (!this.$qrcode) return [];

		let { "params": $params } = $options || {};
		let $contrast: string, { "dataColor": $fill, contrastColor } = $params || {}

		if(!contrastColor){
			const $rgb = hexToRgbTo($fill);
			$contrast = $rgb < 180 ? '#ffffff' : '#000000';
		}else{
			$contrast = contrastColor
		}

		return [<g name={'other-data'} fill={$contrast}>
			{this.elements(this.getOptions(false, $contrast, $options))}
		</g>];}
	/**
	 *
	 * @param $options
	 */
	public listPoints($options: any = {}): any[]{
		if (!this.$qrcode) return [];
		return [<g name={'data'} fill={$options?.params?.dataColor}>
			{this.elements(this.getOptions(true, $options?.params?.dataColor, $options))}
		</g>];
	}
}
